import { reactive } from '@wix/bex-utils';
import { RefObject } from './RefObject';
import { makeObservable, observable } from 'mobx';
import { isMobileDevice } from '../util/mobileDetection';

export interface PageStateParams {}

// CAIRO-3582: modify mobile detection to use user agent
// export const MOBILE_BREAKPOINT = 768;
export class PageState {
  readonly modalsContainerRef: RefObject<HTMLElement>;

  readonly stackingRootRef: RefObject<HTMLElement>;

  readonly scrollableContentRef: RefObject<HTMLElement>;

  _sidePanelOpen = reactive<boolean>(false);

  _isMobile = false;

  constructor() {
    this.modalsContainerRef = makeObservable(
      { current: null },
      { current: observable.ref },
    );
    this.stackingRootRef = { current: null };
    this.scrollableContentRef = { current: null };

    makeObservable(this, {
      _isMobile: observable.ref,
      // CAIRO-3582: modify mobile detection to use user agent
      // _updateIsMobile: action.bound,
    });

    this._isMobile = isMobileDevice();
  }

  // CAIRO-3582: modify mobile detection to use user agent
  // _updateIsMobile() {
  //   if (typeof window !== 'undefined') {
  //     this._isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
  //   }
  // }

  get isMobile() {
    return this._isMobile;
  }

  set sidePanelOpen(value: boolean) {
    this._sidePanelOpen.value = value;
  }

  // CAIRO-3582: modify mobile detection to use user agent
  // init() {
  //   if (typeof window === 'undefined') {
  //     return;
  //   }
  //   this._updateIsMobile();
  //   const container = this.stackingRootRef.current ?? document.body;
  //   const disposers = [addResizeObserver(container, this._updateIsMobile)];
  //   return () => {
  //     disposers.forEach((d) => d?.());
  //   };
  // }
}
